import React, { Fragment, useEffect } from 'react';
import { ModalType, useFormikTransferFilters } from '../../../../utils';
import InventoryView from '../views/InventoryView';
import { ShareResponse, useSupervisors } from '../../../../share';
import InventoryDetailContainer from '../../../InventoryView/components/containers/InventoryDetailContainer';
import InventoryManageContainer from '../../../InventoryView/components/containers/InventoryManageContainer';
import { useFetchTransferRequests } from '../../../../hooks';
import { TransfersFilter } from '../../../Transfers/types/transfers-response';

const InventoryViewContainer: React.FC = () => {
  const { data: supervisors } = useSupervisors();
  const [modalState, setModalState] = React.useState<{
    type: ModalType;
    technicalId?: string;
  }>({ type: null, technicalId: undefined });

  const storedAuth = JSON.parse(localStorage.getItem('auth') || '{}');
  const userId = storedAuth?.user?.id;
  const [filter, setFilter] = React.useState<TransfersFilter>({
    new_responsible_id: userId,
  });

  const {
    data: tranfers,
    isPending: loadList,
    refetch,
  } = useFetchTransferRequests(filter);

  const handleFilter = async (values: Partial<TransfersFilter>) => {
    const finalFilter = {
      ...values,
      new_responsible_id: userId,
      created_at: values.created_at
        ? new Date(values.created_at).toISOString().split('T')[0]
        : '',
    };
  
    setFilter(finalFilter);
  };
  
  const formikFilter = useFormikTransferFilters({ onSubmit: handleFilter });

  const handleViewCreate = () => {
    setModalState({ type: 'create', technicalId: undefined });
  };

  const handleViewDetail = (id: string) => {
    setModalState({ type: 'detail', technicalId: id });
  };

  const handleManageDetail = (id: string) => {
    setModalState({ type: 'manage', technicalId: id });
  };

  const handlePagination = (page: number) => {
    setFilter({
      page: page.toString(),
    });
  };
  

  const transferStates: ShareResponse[] = [
    { id: '8', name: 'Por aprobar' },
    { id: '10', name: 'Rechazado' },
    { id: '12', name: 'Por registrar' },
    { id: '11', name: 'Anulado' },
    { id: '7', name: 'Finalizado' },
  ];

  useEffect(() => {
    refetch(); 
  }, []);
  
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        refetch(); 
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const closeModal = () => {
    setModalState({ type: null, technicalId: undefined });
    refetch();
  };
  

  return (
    <Fragment>
      <InventoryManageContainer
        isOpen={modalState.type === 'manage'}
        OnClose={closeModal}
        technicalId={modalState.technicalId}
        onViewDetail={handleViewDetail}
      />
      <InventoryDetailContainer
        isOpen={modalState.type === 'detail'}
        OnClose={closeModal}
        technicalId={modalState.technicalId}
        onViewDetail={handleViewDetail}
      />
      <InventoryView
        isLoading={loadList}
        data={tranfers}
        states={transferStates}
        supervisors={supervisors}
        formik={formikFilter}
        onViewDetail={handleViewDetail}
        onManageDetail={handleManageDetail}
        onViewCreate={handleViewCreate}
        onPagination={handlePagination}
        onResetFilters={() => {
          handleFilter({});
          formikFilter.resetForm();
        }}
      />
    </Fragment>
  );
};

export default InventoryViewContainer;
